import { render, staticRenderFns } from "./ButtonListPurchaseBuyers.vue?vue&type=template&id=6fa665b4&"
import script from "./ButtonListPurchaseBuyers.vue?vue&type=script&lang=ts&"
export * from "./ButtonListPurchaseBuyers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports